<!-- adding recipient component  -->
<template>
    <!-- methods of adding it -->
    <div class="container-fluid">
        <div class="p-4 row justify-content-center">
            <div class="col-12 col-md-12">
                <h3 class="head-title">How would you like to add contacts?</h3>
                <p class="p">Build your Mailchimp audience by adding or importing contacts you already <br>
                have permission to market to.</p> 
            </div>
        </div>
        <div class=" p-4 row mt-5">
            <!--  -->
            <div class="col-md-3 mb-2">
                <div class="card" >
                    <div class="card-body p-3">
                    <i class="fas fa-file-import"></i>
                      <h5 class="card-text">Import from another service</h5> 
                       <p class="p-2">Add contacts automatically from tools you already use.</p> 
                    </div>
                </div>
            </div>
            <!--  -->
            <div class="col-md-3 mb-3">
                <div class="card" @click="copyPasteMethod">
                    <div class="card-body p-3">
                    <i class="fa fa-copy"></i>
                      <h5 class="">Copy and paste</h5> 
                       <p class="p-2">Directly paste in new contacts from a spreadsheet or similar list.</p> 
                    </div>
                </div>
            </div>
            <!--  -->

            <div class="col-md-4">
                <div class="card" @click="uploadMethod">
                    <div class="card-body p-3">
                        <i class="fas fa-upload"></i>
                          <h5 class="card-text">Upload a file</h5> 
                           <p class="p-2">Import contacts from a CSV or tab-delimited TXT file More info</p> 
                    </div>
                </div>
            </div>
            <!--  -->
            <div class="col-md-1">

            </div>
        </div>

    </div>
</template>

<script>
export default {
    data:()=>({

    }),

    methods:{
        copyPasteMethod(){
            this.$router.push('/create_mail/'+ 1)
        },
        uploadMethod(){
            this.$router.push('/create_mail/'+ 2)
        }
    }
}
</script>

<style lang="css" scoped>
    @import "https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700";
    .head-title{
        font-family: 'Poppins';
        /* color: red; */
    }
    h5 {
         font-family: 'Poppins';
    }
    .fa,.fas{
        font-size: 25px;
        color: #0085A1;
    }
    .card-body:hover{
        cursor: pointer;
        background-color: rgba(243, 243, 243, 0.397);
    }
  
</style>